import React from 'react';

import HelpOutlineRoundedIcon from '@mui/icons-material/HelpOutlineRounded';
import { styled } from '@mui/system';

import Link from '@ui/link/Link';

import useCms from '@components/Cms/useCms';
import usePodcasterLevelDialog from '@components/PodcasterLevelDialog/usePodcasterLevelDialog';

const DetailLinkContainer = styled('div')({
    cursor: 'pointer',
    display: 'flex',
});

const PodcasterProfileLevelDetailLink = ({ detailed }) => {
    const cms = useCms();
    const { openPodcasterLevelDialog } = usePodcasterLevelDialog();
    return (
        <DetailLinkContainer onClick={openPodcasterLevelDialog}>
            <HelpOutlineRoundedIcon />
            {detailed && (
                <Link href="#0" color="inherit" sx={{ paddingLeft: 1 }}>
                    {cms[3026]}
                </Link>
            )}
        </DetailLinkContainer>
    );
};

export default PodcasterProfileLevelDetailLink;
